<template>
  <v-card :disabled="lockPersonalSettings">
    <v-card-title>
      {{ $t('settings.user.title') }}
    </v-card-title>
    <v-card-text class="pa-6">
      <v-row>
        <v-col xl="6" sm="12">
          <Field icon="shield-account" :rules="[required]"
            :label="$t('settings.user.lbl.username')"
            v-model="username" />
          <Field icon="at" v-model="email" :rules="[required]"
            :label="$t('settings.user.lbl.email')" />
        </v-col>
        <v-col xl="6" sm="12">
          <Field icon="lock" password v-model="password" :err="err.pwdNew"
            :label="$t('settings.user.lbl.pwdNew')" />
          <Field icon="lock-check" password :rules="[confirmMatch]"
            :label="$t('settings.user.lbl.pwdConfirm')" :err="err.pwdConfirm"
            v-model="pwdConfirm" />
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-icon color="red" v-show="lockPersonalSettings">mdi-lock</v-icon>
      <v-btn text @click="save">{{ $t('settings.user.btn.save') }}</v-btn>
      <v-spacer></v-spacer>
      <v-btn text :disabled="!otpCanRead"
        :color="otpColor" @click="showOTP=true" class="otp-button">
        <v-icon>{{ otpIcon }}</v-icon>
        {{ $t('settings.user.btn.otp') }}
      </v-btn>
    </v-card-actions>
    <OTPForm :show="showOTP" @close="onCloseOTPForm()"/>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Field from './field'
import OTPForm from './otpform'
import API from '@/api'
import events from 'Store/events'

export default {
  name: 'settings-user',
  components: { Field, OTPForm },
  data () {
    return {
      password: '',
      pwdConfirm: '',
      showOTP: false,
      err: {
        pwdNew: [],
        pwdConfirm: []
      }
    }
  },
  watch: {
    password: function () {
      if (this.err.pwdNew.length > 0) {
        this.err.pwdNew.splice(0)
        this.err.pwdConfirm.splice(0)
      }
    },
    pwdConfirm: function () {
      if (this.err.pwdConfirm.length > 0) {
        this.err.pwdNew.splice(0)
        this.err.pwdConfirm.splice(0)
      }
    }
  },
  computed: {
    ...mapGetters({
      userID: 'settings/userID',
      storeUsername: 'settings/userName',
      storeEmail: 'settings/userEmail',
      otpCanRead: 'permissions/otpRead',
      otpEnabled: 'settings/otpEnabled',
      isOwnerCurUser: 'settings/isOwnerCurUser'
    }),
    username: {
      get: function () {
        return this.storeUsername
      },
      set: function (val) {
        this.setUsername(val)
      }
    },
    email: {
      get: function () {
        return this.storeEmail
      },
      set: function (val) {
        this.setEmail(val)
      }
    },
    otpIcon: function () {
      return this.otpEnabled
        ? 'mdi-shield-lock'
        : 'mdi-shield-lock-open-outline'
    },
    otpColor: function () {
      return this.otpEnabled
        ? 'green'
        : 'red'
    },
    lockPersonalSettings: function () {
      return !this.isOwnerCurUser
    }
  },
  methods: {
    ...mapActions({
      setUsername: 'settings/setUsername',
      setEmail: 'settings/setUserEmail',
      reloadOTPSettings: 'settings/reloadOTPSettings'
    }),
    required: function (val) {
      return val.length > 0 || this.$t('settings.user.err.required')
    },
    confirmMatch: function () {
      return (this.pwdConfirm === this.password) ||
        this.$t('settings.user.err.pwdMatch')
    },
    onCloseOTPForm () {
      // reset form and otp btn status
      this.reloadOTPSettings()
      this.showOTP = false
    },
    validPassword: function () {
      if (!this.password && !this.pwdConfirm) {
        // both password and confirm password are empty
        // user does not want to update password
        return true
      }
      if (this.password.trim().length > 0 && this.pwdConfirm.trim().length === 0) {
        this.err.pwdNew.push(this.$t('settings.user.err.pwdMatch'))
        this.err.pwdConfirm.push(this.$t('settings.user.err.pwdMatch'))
        return false
      }
      return this.password === this.pwdConfirm
    },
    validate: function () {
      const validStr = (val) => {
        return typeof val === 'string' && val.trim().length > 0
      }
      return validStr(this.username) &&
        validStr(this.email) &&
        this.validPassword()
    },
    save: function () {
      if (!this.validate()) {
        this.dbg('Form is invalid')
        return
      }
      const config = {
        username: this.username,
        email: this.email,
        ...(this.password.length > 0 ? { password: this.password } : {})
      }
      events.mask()
      API.updateUser(this.userID, config).then(resp => {
        this.dbg('user updated')
        this.dbg(resp)
        events.pubNotify({ text: 'settings.user.updateOk', status: 'success' })
      }).catch(err => {
        this.dbg(err)
        events.pubError(this.$t('settings.user.err.update') +
          API.getException(err))
      }).finally(() => {
        events.unmask()
      })
    }
  }
}
</script>

<style scoped>
</style>
